"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("@material-ui/core/Button");
const Grid_1 = require("@material-ui/core/Grid");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const react_i18next_1 = require("react-i18next");
const package_1 = require("../package");
const FailedTransactionModal = ({ classes, open, onClose, transactionNumber, proceedToPay }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(package_1.InformationDialog, Object.assign({ open: open, onClose: onClose, maxWidth: 'md', hideButton: true, hideXButton: true }, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, spacing: 2, className: classes.content }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "h5", color: "error", align: 'center', className: classes.title }, { children: t('store.orderFailed.title') })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "body1", className: classes.text, align: 'center' }, { children: t('store.orderFailed.transaction', { id: transactionNumber }) })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "subtitle1", className: classes.text, align: 'center' }, { children: t('store.orderFailed.error') })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12, className: classes.btnContainer }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: 'text', size: 'large', color: 'primary', onClick: proceedToPay, className: classes.button }, { children: t('store.orderFailed.tryAgain') })) }))] })) })));
};
const styles = (theme) => (0, styles_1.createStyles)({
    content: {
        padding: theme.spacing(2)
    },
    title: {
        marginBottom: theme.spacing(2)
    },
    btnContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    text: {
        color: theme.palette.common.black
    },
    button: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        color: theme.palette.secondary.dark
    }
});
exports.default = (0, styles_1.withStyles)(styles)(FailedTransactionModal);
//# sourceMappingURL=FailedTransactionModal.js.map